import Shimmer from "components/ui/shimmer"

const FilterAccordionLoading = () => (
  <>
    {[...Array(5)].map((_, i) => (
      <div className="py-16" key={`filter-accordion-loading-${i}`}>
        <Shimmer style={{ height: "20px" }} />
      </div>
    ))}
  </>
)

export default FilterAccordionLoading
